
import React from 'react'

import http from '../../../lib/http'
import { AutoComplete } from '../../shared/NarusMaterial'

import { makeAutobindedInput } from './FormBuilder'

// "SCD,SBD,SBDF,SCDF,GPCK,BPCK,PSN" all tty options <--

const textFunc = obj => obj.text || obj.display

const displayFunc = obj => [
  obj.text || obj.display,
  <div
    key={1}
    className='nh-info'
  >
    {obj._tty} {obj?.code ?? ''}
  </div>
]

class RxnormAutocompleteField extends React.Component {
  constructor (props) {
    super(props)
    this.state = {}
    this.dataFunc = this.dataFunc.bind(this)
    this.handle = this.handle.bind(this)
  }

  dataFunc (text) {
    if (text && text.length > 0) {
      const { tty } = this.props
      return new Promise(resolve => {
        const search = {
          text,
          perpage: 30,
          tty
        }
        http
          .getRequest(encodeURI('/terminology/rxnorm/medications'), search)
          .then(data => {
            const regexp = new RegExp(
              text.toLowerCase().split(/\s+/).join('.*?')
            )

            const terms = data.filter(d =>
              d.display.toLowerCase().match(regexp))
            if (terms.length === 0) {
              resolve('Sorry, no results found.')
            } else {
              resolve(terms)
            }
          })
          .catch(() => {
            resolve('Please enter more search criteria')
          })
      })
    }
    return Promise.resolve('Please enter search criteria for Rxnorm')
  }

  handle (v) {
    const { onChange } = this.props
    if (onChange) {
      if (v) {
        onChange({
          code: v.code,
          display: v.display,
          system: v.system
        })
      } else {
        onChange(null)
      }
    }
  }

  render () {
    const { label, value, ...rest } = this.props
    return (
      <AutoComplete
        {...rest}
        label={label || 'Medication Name'}
        dataFunc={this.dataFunc}
        textFunc={textFunc}
        displayFunc={displayFunc}
        value={value}
        onChange={this.handle}
      />
    )
  }
}

export const RxnormAutocompleteInput = makeAutobindedInput(
  RxnormAutocompleteField
)
